import React, { useEffect, useState } from "react";
import Scrollbar from "../scrollbar";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";
import { addisLoading, addlessThanTwoStar } from "../../utils/redux/mainSlice";
import { getLessThanTwoStars } from "../../utils/apis/func";
import { formatDate } from "../helpers/walletTabs/tempFour";

type StatusColors = {
  pending: string;
  accepted: string;
  inprogress: string;
  "in dispute": string;
  track: string;
  completed: string;
  declined: string;
  cancelled: string;
};

const LessThanTwoStars = () => {
  const dispatch = useAppDispatch();
  const lessThanTwoStars = useAppSelector(
    (store: RootState) => store.user.lessThanTwoStars
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      dispatch(addisLoading(true));
      const res: any = await getLessThanTwoStars("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addlessThanTwoStar(res?.data?.data));
      }
      dispatch(addisLoading(false));
    })();
  }, [dispatch]);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const totalItems = lessThanTwoStars?.length;
  const itemsPerPage = 15;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const filteredItemsToShow = lessThanTwoStars?.slice(startIndex, endIndex);

  console.log(filteredItemsToShow);

  const getStatusColor = (status: keyof StatusColors): string => {
    const statusColors: StatusColors = {
      pending: "bg-yellow-700",
      accepted: "bg-green-500",
      inprogress: "bg-blue-500",
      "in dispute": "bg-red-500",
      track: "bg-purple-500",
      completed: "bg-teal-500",
      declined: "bg-gray-500",
      cancelled: "bg-red-500",
    };
    return statusColors[status] || "bg-gray-500"; // Default to gray if status is not found
  };

  return (
    <div className="overflow-auto ">
      <div className="flex justify-between my-2 px-6">
        <p className="text-[#88087B] font-roboto text-xl lg:text-3xl font-medium leading-normal">
          Less Than Two Stars
        </p>
      </div>
      <section className="mt-2">
        <input
          type="search"
          className="border m-6 border-gray-300 rounded-full px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          placeholder="Search by order id"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="overflow-auto  rounded-t-lg">
          <table
            className="w-full table-auto"
            style={{ width: "100% !important" }}
          >
            <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-sm lg:text-base font-medium text-center whitespace-nowrap space-x-4 lg:space-x-0">
              <tr className="whitespace-nowrap">
                <th className="py-6 text-center gap-2">Date</th>
                <th className="py-3">Amount</th>
                <th className="py-3">Order ID</th>
                <th className="py-3"> Service Provider</th>
                <th className="py-3 max-w-sm">Customer Name</th>
                <th className="py-3  max-w-sm">Service Name</th>
                <th className="py-3"> Job Description</th>
                <th className="py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredItemsToShow
                ?.filter((item: any) =>
                  `${item._id}`.toLowerCase()?.includes(searchTerm.toLowerCase())
                )
                .map((item) => (
                  <tr
                    onClick={() => {}}
                    key={item?._id}
                    className="hover:bg-[#87878d]  transition duration-300 font-roboto text-xs font-medium leading-normal border border-b-[#525050] text-center"
                  >
                    <td className=" py-4whitespace-nowrap">
                      {formatDate(item?.createdAt)}
                    </td>
                    <td className="whitespace-nowrap">{item?.amount}</td>
                    <td className="whitespace-nowrap">{item?._id}</td>
                    <td className="whitespace-nowrap">
                      {item?.serviceProvider.fullName}
                    </td>
                    <td className="p-2 max-w-md">{item?.user?.fullName}</td>
                    <td className="p-2 max-w-md">{item?.service?.name}</td>
                    <td className="whitespace-nowrap">{item?.description}</td>
                    <td className="whitespace-nowrap">
                      <p
                        className={`text-white px-2 py-1 rounded-lg ${getStatusColor(
                          item?.status.toLowerCase() as keyof StatusColors
                        )}`}
                      >
                        {item?.status}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {filteredItemsToShow.length < 1 && (
            <div className="py-8">
              <p className="font-bold text-2xl text-center">
                No Data to display
              </p>
            </div>
          )}
        </div>
        <Scrollbar
          currentPage={currentPage}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
        />
      </section>
    </div>
  );
};

export default LessThanTwoStars;
